import React, { useCallback } from 'react';
import { TableCell, TableSortLabel } from "@mui/material";
import { SortBy, SortDir } from "../../model/DataQueryParams";
import { makeStyles } from "@mui/styles";

const SortableTableHeader: React.FC<SortableTableHeaderProps> = props => {
    const styles = useStyles();

    const onClick = useCallback(() => {
        props.onClick(props.field);
    }, [props.field, props.onClick]);

    return (
        <TableCell title={ props.title }>
            <TableSortLabel
                active={ props.currentSortBy?.field === props.field }
                direction={ props.currentSortBy?.dir === SortDir.DESC ? 'desc' : 'asc' }
                onClick={ onClick }
                className={ styles.sortLabel }
            >
                { props.children }
            </TableSortLabel>
        </TableCell>
    );
}
export default SortableTableHeader;

export interface SortableTableHeaderProps {
    readonly field: string;
    readonly currentSortBy: SortBy | undefined;
    readonly onClick: (field: string) => void;
    readonly children?: React.ReactNode;
    readonly title?: string;
}

const useStyles = makeStyles(theme => ({
    sortLabel: {
        textDecoration: 'underline solid ' + theme.palette.secondary.main + ' !important'
    }
}))